export default __webpack_public_path__ + "static/media/Standard24.da8f2412.png";